import { all, put, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getRefundInfoRequest } from '../../api/Marketplace/getRefundInfoQuery';

import * as ActionTypes from './actionTypes';

function* loadRefundsWorker({ payload: fileId }) {
  yield executeSagaRequest(
    ActionTypes.LOAD_REFUNDS,
    getRefundInfoRequest({ fileId }),
    { indexer: fileId, fileId },
  );

  yield put(ActionTypes.LOAD_REFUNDS.end({ fileId }));
}

function* loadRefundsWatcher() {
  yield takeEvery(ActionTypes.LOAD_REFUNDS.BASE, loadRefundsWorker);
}

export default function* refundsSaga() {
  try {
    yield all([loadRefundsWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
